import { readCookie } from './readCookie';
export const cookieCategoryToCodeMap = {
    essential: 'C0001',
    analytics: 'C0002',
    marketing: 'C0004',
};
export const canWriteCookieCategory = (category) => {
    if (category === 'essential') {
        return true;
    }
    const optanonConsent = readCookie('OptanonConsent');
    const groups = new URLSearchParams(optanonConsent).get('groups') || '';
    const categoryCode = cookieCategoryToCodeMap[category];
    const categoriesByCode = groups
        .split(',')
        .map((group) => group.split(':'))
        .reduce((accum, [catCode, stringBoolean]) => {
        accum[catCode] = stringBoolean === '1' ? true : false;
        return accum;
    }, {});
    return categoriesByCode[categoryCode];
};
//# sourceMappingURL=categories.js.map
// @zapier/cookies@1.0.2 (aeccc3fd4)
